export default "__VITE_ASSET__Dky0lBrT__"